import { ReactElement } from "react";
import { ButtonBase } from "../ButtonBase/ButtonBase";
import { Icon } from "../Icon/Icon";
import styles from "./PinButton.module.less";

export type PinButtonProps = {
	onClick: () => void;
	isPinned: boolean;
	trackingId: string;
};

export const PinButton = (props: PinButtonProps): ReactElement => {
	const {
		isPinned,
		onClick,
		trackingId
	} = props;

	return (
		<ButtonBase
			className={styles.root}
			onClick={onClick}
			trackingId={trackingId}
		>
			<Icon
				value={isPinned ? "chevron-left" : "chevron-right"}
			/>
		</ButtonBase>
	);
};
PinButton.displayName="PinButton";
